import { Highlight } from '@curology/ui-components-web/react/Highlight';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { type Card } from '@/types/productSelectionAndCheckout/types';

import { ModalImage } from '../ModalImage';
import { ModalPricingVolumeAndProductOptionSelector } from '../ModalPricingVolumeAndProductOptionSelector';
import { ModalRatingAndNumReviews } from '../ModalRatingAndNumReviews';

export const MicellarMakeupRemoverModalContent = ({
  modalCard,
}: {
  modalCard: Card;
}) => {
  const { modal } = modalCard;

  return (
    <>
      <ModalImage modal={modal} />
      <Typography className="cur-mt-4" size="h2">
        {modal.title}
      </Typography>
      <ModalPricingVolumeAndProductOptionSelector modalCard={modalCard} />
      {modalCard.recommendationText && (
        <Highlight className="cur-mt-4" state="success">
          <div
            dangerouslySetInnerHTML={{
              __html: modalCard.recommendationText.modalCallout,
            }}
          ></div>
        </Highlight>
      )}
      <ModalRatingAndNumReviews modalCard={modalCard} />
      <Typography className="cur-mt-4" size="h3">
        Why it&apos;s special
      </Typography>
      <Typography className="cur-mt-4">
        Makeup, removed. Our defiantly gentle micellar makeup remover is
        designed to actually care for your skin while you wipe away the day.
        Tiny micelles work like magnets, encapsulating and lifting away dirt,
        oil, and even the most stubborn waterproof makeup—so your Custom Formula
        can get to work.
      </Typography>
      <Typography className="cur-mt-4">
        The first step in your essential anti-acne routine, our gel-water
        formula leaves your skin soft and hydrated. No harsh rubbing, stinging,
        or blurry eyes. Just that easy fresh face.
      </Typography>
      <Typography className="cur-mt-4" size="h3">
        How to use it
      </Typography>
      <Typography className="cur-mt-4">
        Simply dampen a cotton pad and gently wipe over eyes, skin, and lips.
        Hold on top of waterproof makeup for 3 seconds before wiping away. No
        need to rinse.
      </Typography>
      <Typography className="cur-mt-4">
        For a full face deep clean, finish off your essential anti-acne routine
        with the cleanser by Curology. Your pores (and pillowcase) will thank
        you.
      </Typography>
      <Typography className="cur-mt-4" size="h3">
        Full ingredients list
      </Typography>
      <Typography className="cur-mt-4">
        Water/Aqua/Eau, PEG-6 Caprylic/Capric Glycerides, Decyl Glucoside,
        Hexylene Glycol, Phenoxyethanol, Acrylates/C10-30 Alkyl Acrylate
        Crosspolymer, Disodium EDTA, Ethylhexylglycerin, Sodium Hydroxide
      </Typography>
    </>
  );
};
